import LongRectangleTextButton from 'components/atoms/longRectangleTextButton';
import RectangleImageButton from 'components/atoms/rectangleImageButton';
import AdminPanelUI from 'components/molecules/adminPanelUI';
import ContactDataList from 'components/molecules/contactDataList';
import {useAdminTeachersStore, useLoaderStore} from 'contexts/StoreContext';
import {useTheme} from 'contexts/ThemeContext';
import {observer} from 'mobx-react';
import {PersonalData} from 'models/Admin';
import {Screens} from 'navigations/Screens';
import React, {useEffect} from 'react';
import {View} from 'react-native';
import strings from 'translations/index.web';
import styleSheet from './styles';

const AdminPanelTeachers = observer(() => {
  const theme = useTheme();
  const styles = styleSheet(theme);

  const teachersStore = useAdminTeachersStore();
  const loaderStore = useLoaderStore();

  const flatListData = teachersStore.teachers;

  useEffect(() => {
    teachersStore.fetchTeachers();
  }, []);

  const handleDelete = (deletable: PersonalData) => {
    teachersStore.deleteTeacher(deletable);
  };

  const handleAdd = () => {
    teachersStore.addEmptyTeacher();
  };

  const onFieldChanged = (
    text: string,
    arrIndex: number,
    fieldName: string,
  ) => {
    teachersStore.setField(text, arrIndex, fieldName);
  };

  const handleSaveFields = async () => {
    await teachersStore.updateTeachers();
  };

  const ListView = (
    <View style={styles.listContainer}>
      <ContactDataList
        flatListData={flatListData}
        onPressDelete={item => handleDelete(item)}
        onFieldEdit={(text, index, fieldName) =>
          onFieldChanged(text, index, fieldName)
        }
      />
      <View style={styles.buttonContainer}>
        <RectangleImageButton
          image={theme.images.addIcon}
          backgroundColor={theme.colors.white}
          onPress={() => handleAdd()}
        />
      </View>
    </View>
  );

  return (
    <AdminPanelUI
      title={strings.admin.teachers}
      activeName={Screens.AdminPanelTeachersScreen.name}>
      <View>
        {ListView}
        <LongRectangleTextButton
          onPress={() => handleSaveFields()}
          title={strings.profile.save}
          titleColor={styles.saveButtonTextColor}
          buttonStyle={styles.saveButtonStyle}
        />
      </View>
    </AdminPanelUI>
  );
});

export default AdminPanelTeachers;
